import { NS_CONFIGURATION, PROJECT, EDITOR, TAG } from 'redux/constants';
import { action, createType, ASYNC, SYNC } from 'redux-create-type';


export const {
  INIT,
  SAVE,
  ADD,
  REMOVE,
  SET_REMOVED,
  SET_NAME,
  INVALIDATE,
  RESET_CHANGES,
  CHECK_VALIDATION,
} = createType(NS_CONFIGURATION, PROJECT, EDITOR, TAG)({
    INIT: ASYNC,
    SAVE: ASYNC,
    ADD: ASYNC,
    REMOVE: ASYNC,
    SET_REMOVED: ASYNC,
    SET_NAME: ASYNC,
    INVALIDATE: SYNC,
    RESET_CHANGES: ASYNC,
    CHECK_VALIDATION: ASYNC,
  });

export const init = {
  begin: ({ projectId }) => action(INIT.BEGIN, { projectId }),
  end: ({
    tags,
    tagOptions,
       }) => action(INIT.END, {
      tags,
      tagOptions,
    }),
};
export const save = {
  begin: () => action(SAVE.BEGIN),
  end: ({
    tags,
    }) => action(SAVE.END, {
      tags,
    }),
};
export const add = {
  begin: () => action(ADD.BEGIN),
  end: ({
    tagOptions,
    }) => action(ADD.END, {
      tagOptions,
    }),
};
export const remove = {
  begin: localId => action(REMOVE.BEGIN, { localId }),
  end: ({
    tagOptions,
    }) => action(REMOVE.END, {
      tagOptions,
    }),
};
export const setRemoved = {
  begin: ({ localId, value }) => action(SET_REMOVED.BEGIN, { localId, value }),
  end: ({
    tagOptions,
    }) => action(SET_REMOVED.END, {
      tagOptions,
    }),
};
export const setName = {
  begin: ({ localId, name }) => action(SET_NAME.BEGIN, { localId, name }),
  end: ({
    tagOptions,
    }) => action(SET_NAME.END, {
      tagOptions,
    }),
};
export const invalidate = ({ tagOptions, changes }) => action(INVALIDATE, { tagOptions, changes });
export const resetChanges = {
  begin: () => action(RESET_CHANGES.BEGIN),
  end: ({
    tagOptions,
    }) => action(RESET_CHANGES.END, {
      tagOptions,
    }),
};
export const checkValidation = {
  begin: () => action(CHECK_VALIDATION.BEGIN, {}),
  end: ({ errors }) => action(CHECK_VALIDATION.END, { errors }),
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/tag/actions.js